var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hsp-layout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"HSP","title":"HSP"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Users',
            icon: 'tim-icons icon-badge',
            path: { name: 'Users' }
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Add User',
            icon: 'tim-icons icon-simple-add',
            path: { name: 'AddUser' }
          }}})],1)],2)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }